module.exports = __webpack_public_path__ + "img/puzzle-piece.ee5bf90e.svg";